import { useEffect, useState } from 'react';

export const useWasClickedOutSide = (containerRef, isListening) => {
  const [clickedOutside, setClickedOutside] = useState(false);
  useEffect(() => {
    const handleExternalClick = (e) => {
      if (!containerRef.current.contains(e.target) && isListening) {
        setClickedOutside(true);
      } else if (clickedOutside) {
        setClickedOutside(false);
      }
    };
    document.addEventListener('mousedown', handleExternalClick);
    document.addEventListener('touchstart', handleExternalClick);
    return () => {
      document.removeEventListener('mousedown', handleExternalClick);
      document.removeEventListener('touchstart', handleExternalClick);
    };
  }, [clickedOutside, containerRef, isListening]);

  return clickedOutside;
};
